import __env from '../../../env'
import instance from '../../../middleware/axiosInstance'
import axios from 'axios'


export const fetchConfig = () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/schema/all`,{withCredentials: true})
}


export const fetchConfigWithPagination = (pageable,search,useCaseStatus) => {
  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/page?useCaseStatus=${useCaseStatus}&pageNo=${pageable.pageNo}&pageSize=${pageable.pageSize}&sortBy=${pageable.sortBy}&sortDir=${pageable.sortDir}&searchBy=${search}`,{withCredentials: true}
  )
}

export const fetchUsecaseIterationsWithPagination = (pageable,usecaseName) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/iterations/usecase?&pageNo=${pageable.pageNo}&pageSize=${pageable.pageSize}&sortBy=${pageable.sortBy}&sortDir=${pageable.sortDir}&useCaseName=${encodeURIComponent(usecaseName)}`,{withCredentials: true}
  )
}

export const fetchIterationById = (id) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/iterations/usecase/${id}`,{withCredentials: true}

  )
}

export const createConfig = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/config`, data,{withCredentials: true})

}

export const addModelPath = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/add-model`, data,{withCredentials: true})
}

export const addFont = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/font/add`, data,{withCredentials: true})

}

export const createWorkflow = (videoConfig,data) => {
  const url = `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/create`
  const params = new URLSearchParams({
    'use-case': data['use-case'],
    'sub-use-case': data['sub-use-case'],
    'template-id': data['template-id'],
    'use-case-type':data['use-case-type']
  });
  return instance.post(`${url}?${params.toString()}`, videoConfig,{withCredentials: true})
}

export const updateConfig = (id, data) => {
  return instance.put(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/${id}`,
    data,{withCredentials: true}
  )
}

export const updateWorkflow = (id, data) => {
  return instance.put(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/update/${id}`,
    data,{withCredentials: true}
  )
}

export const fetchConfigById = id => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/config/${id}`,{withCredentials: true})

}

export const fetchWorkflowByName = id => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/name/${id}`,{withCredentials: true})

}

export const deleteConfig = id => {
  return instance.delete(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/${id}`,{withCredentials: true}
  )
}

export const deleteSchema = id => {
  return instance.delete(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/schema/${id}`,{withCredentials: true}
  )
}

export const uploadUseCaseFiles = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/upload/`, data,{withCredentials: true})
}

export const upload2FAFile = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/customer/upload`, data,{withCredentials: true})
}
export const kdenUpload = (data, options = {}) => {
  return instance.post(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/kden/upload`,
    data,
    {
      withCredentials: true, 
      onUploadProgress: options.onUploadProgress
    }
  );
}

export const fetchModelPath = (model) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/models?model-type=${model}`,{withCredentials: true})
}

export const fetchFont = () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/font/all`,{withCredentials: true})
}

export const fetchMood = () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/mood`,{withCredentials: true})
}

export const fetchLanguage= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/language`,{withCredentials: true})
}

export const fetchTransliterationType= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/type`,{withCredentials: true})
}

export const fetchLipsyncSourceVideoPath= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/source-video-path`,{withCredentials: true})
}

export const fetchLipsyncPretrained= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/pretrained-path`,{withCredentials: true})
}

export const fetchLipsynOpenface= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/landmark-path`,{withCredentials: true})
}

export const fetchStyle= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/style`,{withCredentials: true})
}

export const fetchModels= (gender,language) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/models_by_gender_and_language?language=${language}&gender=${gender}`,{withCredentials: true})
}

export const fetchVcModel= () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/list/vc_model`,{withCredentials: true})
}


export const downloadKdenCsv= (templateId) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/kden/download-csv/${templateId}`,{withCredentials: true})
}

export const downloadKden= (mltFileId) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/kden/${mltFileId}`,{withCredentials: true})
}

export const ChangeConfigStatus = (id) => {
  return instance.put(`${process.env.REACT_APP_CACHE_APPROVE_URL}/admin/config/change/status/${id}`,{withCredentials: true}
)
}

export const downloadUsecaseCsv = (id) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/csv/concat-csv?useCaseId=${id}`,{withCredentials: true})
}

export const CsvUpload = (data) => {
  return instance.post(

    `${process.env.REACT_APP_CACHE_URL}/csv/upload/e2e`,data,{withCredentials: true})
}

export const cacheCsvUpload=(data)=>{
  return instance.post(
    `${process.env.REACT_APP_CACHE_URL}/csv/upload/cache`,data,{withCredentials: true})

}

export const getFinalVideosCount = (useCaseName) => {
  return instance.get(`${process.env.REACT_APP_CACHE_URL}/cache/request/get/count?useCaseName=${useCaseName}`,{withCredentials: true})
}

export const downloadFinalVideosCsv = useCaseId => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/request/download/videos/useCaseId=${useCaseId}`,{withCredentials: true}
  )
}

export const cacheTransliteration = (data) => {
  return instance.post(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/vc/upload?prefix-audio-link=${data['prefix-audio-link']}&suffix-audio-link=${data['suffix-audio-link']}&prefix-user-text=${data['prefix-user-text']}&suffix-user-text=${data['suffix-user-text']}&prefix-source-audio-text=${data['prefix-source-audio-text']}&suffix-source-audio-text=${data['suffix-source-audio-text']}`
  ,{withCredentials: true})
}

export const startUsecase = useCaseId => {
  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/start/${useCaseId}`,{withCredentials: true}
  )
}

export const stopUsecase = useCaseId => {
  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/stop/${useCaseId}`,{withCredentials: true}
  )
}


export const getFontNames = () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/font/all`,{withCredentials: true})
}

export const workflowStateListing = (data) => {
  return instance.post(
    `${process.env.REACT_APP_CACHE_URL}/cache/workflow/get-states`,data,{withCredentials: true}
  )
}

export const getWorkflowStateById = (id) => {
  return instance.get(
    `${process.env.REACT_APP_CACHE_URL}/cache/workflow/${id}`,id,{withCredentials: true}
  )
}


export const updateUsecaseStageById = (id, useCaseStage) => {
  return instance.put(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/stage/update/${id}?use-case-stage=${useCaseStage}`,
    { withCredentials: true }
  );
};


export const deleteWorkflowState = id => {
  return instance.delete(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/config/${id}`,{withCredentials: true}
  )
}

export const emailTemplateUpload = (data, options = {}) => {
  return instance.post(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/email-template/extract-variables`,
    data,
    {
         withCredentials: true, 
      onUploadProgress: options.onUploadProgress,
    },
    
  )
}

export const createEmailTemplate = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/email-template/save`, data,{withCredentials: true})
}

export const createWhatsappTemplate = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/whatsapp-template`, data,{withCredentials: true})
}

export const ClusterCostCount = (data) => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/open-cost/allocation/compute`, data, {
    withCredentials: true 
  });
};

export const VideoMetricCount = (useCaseName) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/assets/stats/all?campaign=${useCaseName}`, {
    withCredentials: true 
  });
};

export const UseCaseStatusCount = () => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/assets/status/all`, {
    withCredentials: true 
  });
};

export const fetchCampaignByName = (campaignName) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/assets/campaigns/search?name=${campaignName}`, {
    withCredentials: true 
  });
};

export const fetchCampaigns = (page,rowsPerPage,campaign) => {
  return instance.get(`${process.env.REACT_APP_SCHEMA_URL}/admin/assets/campaigns?page=${page}&size=${rowsPerPage}&campaign=${campaign}`, {
    withCredentials: true 
  });
};